import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import {
	Dropdown, DropdownDisclosure, DropdownWrapper, useDropdownState
} from 'components/Dropdown';
import { utagLinkPDP } from 'features/tealium';

import {
	updateSortOrder, fetchProductQuestions, SORT_MOST_HELPFUL, SORT_MOST_RECENT
} from '../slice';

import './ProductNewAdditionAndSorting.scss';

const sortOptions = [
	{
		value: SORT_MOST_HELPFUL,
		text: 'Most Helpful'
	},
	{
		value: SORT_MOST_RECENT,
		text: 'Most Recent'
	}
];

const ProductNewAdditionAndSorting = () => {

	const { totalRecords, sortOrder } = useSelector((state) => state.productQuestionsAndAnswers);

	const dispatch = useDispatch();
	const dropdown = useDropdownState(false);
	const activeSortOption = sortOptions.find((s) => s.value === sortOrder);
	const activeSortText = activeSortOption ? activeSortOption.text : sortOptions[0].text;

	const handleSortSelect = ({ value: sortValue, text: sortText }) => {

		// no need to update store if selected sort order is the same as previously selected
		if (sortOrder !== sortValue) {

			dispatch(updateSortOrder(sortValue));

			const fetchParameters = {
				pageNumber: 1,
				pageSize: 3,
				sortOrder: sortValue
			};

			dispatch(fetchProductQuestions(fetchParameters));

			utagLinkPDP('TurnTo')({
				eventAction: `Q&A-Sort-${sortText}`
			});

		}

		dropdown.hideDropdown();

	};
	return (
		<div className="ProductNewAdditionAndSorting">
			<span className="ProductNewAdditionAndSorting__questions">
				{totalRecords}
				{' '}
Question
				{totalRecords !== 1 ? 's' : ''}
			</span>
			<span className="ProductNewAdditionAndSorting__sortBy">Sort by:</span>
			<DropdownWrapper>
				<DropdownDisclosure {...dropdown} className="ProductNewAdditionAndSorting__toggleDropdownBtn">
					<span className="ProductNewAdditionAndSorting__toggleDropdownBtnText">
						{activeSortText}
					</span>
					{' '}
					<span className="ProductNewAdditionAndSorting__toggleDropdownCaret" />
				</DropdownDisclosure>
				{dropdown.show && (
					<Dropdown {...dropdown}>
						<div className="ProductNewAdditionAndSorting__dropdownList">
							{sortOptions.map((option) => (
								<button
									key={option.value}
									type="button"
									onClick={() => handleSortSelect(option)}
									className={classNames('ProductNewAdditionAndSorting__dropdownListItem', {
										'ProductNewAdditionAndSorting__dropdownListItem--active':
											option.value === sortOrder
									})}
									aria-disabled={option.value === sortOrder}
								>
									{option.text}
								</button>
							))}
						</div>
					</Dropdown>
				)}
			</DropdownWrapper>
		</div>
	);

};

export default ProductNewAdditionAndSorting;
